import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { filter, map, Observable, take } from 'rxjs';
import { AuthService, SessionState } from '../services/auth.service';

export function withValidatedSession(checkAccess: () => boolean): boolean | UrlTree | Observable<boolean | UrlTree> {
    const authService = inject(AuthService);
    const router = inject(Router);
    const resolve = (state: SessionState): boolean | UrlTree =>
        state === 'ready' ? checkAccess() : router.createUrlTree(['/home']);
    const state = authService.sessionState();

    return state === 'loading'
        ? toObservable(authService.sessionState).pipe(
            filter(state => state !== 'loading'),
            take(1),
            map(resolve),
        )
        : resolve(state);
}

export const sessionGuard: CanActivateFn = () => withValidatedSession(() => true);
